import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'wsm-skeleton';

const TitleSkeleton = ({ isTabbedLayout }) => (
	<Skeleton
		skeletonClasses="mb-6"
		height="2rem"
		width={isTabbedLayout ? '100%' : '75%'}
		dataTestId="title-skeleton"
	/>
);

TitleSkeleton.propTypes = {
	isTabbedLayout: PropTypes.bool.isRequired
};

export default TitleSkeleton;
